import { Routes } from '@angular/router';
import { authRoutes } from './auth/auth.routes';
import { authGuard } from './shared/guards/auth.guard';
import { BreakageApiService } from './features/breakages/services/breakage-api.service';
import { InventoryApiService } from './features/inventories/services/inventory-api.service';
import { BasicOperationApiService } from './features/basic-operations/services/basic-operation-api.service';
import { ReceiptApiService } from './features/receipts/services/receipt-api.service';
import { DEV_ROUTES } from './dev/dev.routes';

export const routes: Routes = [
	{
		path: 'auth',
		children: authRoutes
	},
	{
		path: 'dev',
		children: DEV_ROUTES
	},
	{
		path: 'login',
		redirectTo: 'auth/login',
		pathMatch: 'full'
	},
	{
		path: '',
		loadComponent: () => import('./shared/layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
		canActivate: [authGuard],
		children: [
			{
				path: '',
				loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
			},
			{
				path: 'destockage',
				providers: [BasicOperationApiService],
				loadChildren: () => import('./features/basic-operations/basic-operations.routes').then(m => m.BASIC_OPERATION_ROUTES)
			},
			{
				path: 'ruptures',
				providers: [BreakageApiService],
				loadComponent: () => import('./features/breakages/breakages.component').then(m => m.BreakagesComponent)
			},
			{
				path: 'inventaires',
				title: 'Inventaires',
				providers: [InventoryApiService],
				loadChildren: () => import('./features/inventories/inventories.routes').then(m => m.INVENTORY_OPERATION_ROUTES)
			},
			{
				path: 'receptions',
				title: 'Réceptions',
				providers: [ReceiptApiService],
				loadChildren: () => import('./features/receipts/receipts.routes').then(m => m.RECEIPT_ROUTES)
			}
		]
	}
];
